<template>
  <div class="filia-form" v-if="isFormRendered">
    <div class="tov-form__wrapper">
      <FirmInput :firm-title="formData.legalPersonInfo.full_name"/>
      <INNInput :firm-info="formData.legalPersonInfo"/>
      <Input
        class="user-logged-form__semi-item"
        :regexp="/[^\d]/g"
        :max-length="8"
        :error="egrError"
        :label="$t('subsidiary_edrpou_code')"
        :value="formData.legalPersonInfo.firmEgr"
        @input="handleFirmEgr"
        @onFocus="egrBlured = false"
        @onBlur="egrBlured = true"/>
      <Input
        class="user-logged-form__item"
        :error="titleError"
        :label="$t('subsidiary_full_name')"
        :value="formData.legalPersonInfo.firmTitle"
        @input="handleFirmTitle"
        @onFocus="titleBlured = false"
        @onBlur="titleBlured = true"/>
    </div>
  </div>
</template>

<script>
import FirmInput from './FirmInput'
import INNInput from './INNInput'
import { mapActions, mapState } from 'vuex'
import Input from '../../../inputs/Input'

export default {
  name: 'FiliaForm',
  components: { Input, FirmInput, INNInput },
  data () {
    return {
      firmEgr: '',
      firmTitle: '',
      isEgrValid: false,
      titleBlured: false,
      egrBlured: false
    }
  },
  computed: {
    ...mapState({
      formData: state => state.checkout.formData,
      isPaymentFormEmpty: state => state.paymentForm.isPaymentFormEmpty,
      needValidation: state => state.checkoutNew.needValidation
    }),
    egrError () {
      return (this.isPaymentFormEmpty || this.egrBlured) && !this.isEgrValid ? this.$t('blank_field_error') : ''
    },
    titleError () {
      return (this.isPaymentFormEmpty || this.titleBlured) && !this.firmTitle ? this.$t('blank_field_error') : ''
    },
    isFormRendered () {
      return this.formData.legalPersonInfo.hasOwnProperty('status') && this.formData.legalPersonInfo.status === 'success'
    }
  },
  methods: {
    ...mapActions(['SET_FORM_DATA', 'FETCH_LEGAL_INFO_BY_CODE']),
    ...mapActions('paymentNew', [
      'SET_LEGAL_PERSON_INFO'
    ]),
    validateMethods () {
      this.egrBlured = true
      this.titleBlured = true
    },
    handleFirmEgr (value) {
      this.isEgrValid = value.length === 8
      if (this.isEgrValid) {
        // Посылает запрос на получение информации по егрпоу
        this.FETCH_LEGAL_INFO_BY_CODE({
          code: value,
          isFilia: true
        })
        this.titleBlured = false
      }
      this.SET_FORM_DATA({
        legalPersonInfo: {
          ...this.formData.legalPersonInfo,
          firmEgr: value
        }
      })
      this.SET_LEGAL_PERSON_INFO({
        ...this.formData.legalPersonInfo,
        firmEgr: value
      })
    },
    handleFirmTitle (value) {
      this.firmTitle = value

      this.SET_FORM_DATA({
        legalPersonInfo: {
          ...this.formData.legalPersonInfo,
          firmTitle: value
        }
      })
      this.SET_LEGAL_PERSON_INFO({
        ...this.formData.legalPersonInfo,
        firmTitle: value
      })
    }
  },
  mounted () {
    if (this.formData && this.formData.legalPersonInfo) {
      const { firmEgr, firmTitle } = this.formData.legalPersonInfo
      if (firmEgr) {
        this.isEgrValid = firmEgr.length === 8
        this.firmEgr = firmEgr
      }
      if (firmTitle) this.firmTitle = firmTitle
    }
  },
  watch: {
    formData: {
      deep: true,
      handler (val) {
        if (val.legalPersonInfo.firmTitle) {
          this.firmTitle = val.legalPersonInfo.firmTitle
        }
      }
    },
    needValidation () {
      this.validateMethods()
    }
  }
}
</script>

<style lang="sass" scoped>
  .user-logged-form__semi-item
    margin-bottom: 10px
</style>
